"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _jsxRuntime = require("react/jsx-runtime");
function getSaveObject(saveHeart, suffix, type, filterType) {
  var _saveHeart$brand;
  const obj = {};
  obj[`${type === "inv" ? `dg-inline-saves-inv-${saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.vin}${suffix}` : `dg-inline-saves-${type}-${suffix}`}`] = {
    type: type,
    brand: (saveHeart === null || saveHeart === void 0 ? void 0 : (_saveHeart$brand = saveHeart.brand) === null || _saveHeart$brand === void 0 ? void 0 : _saveHeart$brand.toLowerCase()) === "lexus" ? "Lexus" : "Toyota",
    modelCd: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.modelCd,
    dealerCd: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.dealerCd,
    advertisedPrice: (saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.advertisedPrice) || 0,
    imageHref: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.imageHref,
    imagePrice: (saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.imagePrice) || 0,
    marketingSeries: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.marketingSeries,
    marketingName: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.marketingName,
    year: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.year,
    vin: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.vin,
    price: (saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.price) || 0,
    ePrice: 0,
    vdpHref: "https://stage2-1.dealeron.us/new-St+Robert-2019-Toyota-Corolla-LE-2T1BURHE3KC166216",
    vlpHref: "https://www.toyota.com/tacoma/",
    link_module: saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.linkModule,
    inv_filter_type: filterType,
    ...saveHeart
  };
  return obj;
}
const DGSaveHeart = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  var _saveHeart$brand2;
  const {
    disabled,
    suffix,
    saveHeart,
    type = "inv",
    filterType
  } = props;
  const saveData = getSaveObject(saveHeart, suffix, type, filterType);
  (0, _react.useEffect)(function () {
    var _window, _window$DGDataHub, _window$DGDataHub$ren;
    if (disabled) {
      return;
    }
    if (Object.keys(saveData).length > 0) (_window = window) === null || _window === void 0 ? void 0 : (_window$DGDataHub = _window.DGDataHub) === null || _window$DGDataHub === void 0 ? void 0 : (_window$DGDataHub$ren = _window$DGDataHub.renderInlineSaves) === null || _window$DGDataHub$ren === void 0 ? void 0 : _window$DGDataHub$ren.call(_window$DGDataHub, saveData);
  }, [disabled, saveData]);
  (0, _react.useEffect)(function () {
    return function () {
      const p = document.querySelector(".tooltip.dg-tooltip");
      if (p !== null && p !== void 0 && p.style) {
        p.style.visibility = "hidden";
      }
    };
  }, []);
  if (props.disabled) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    id: `${type === "inv" ? `dg-inline-saves-${type}-${saveHeart === null || saveHeart === void 0 ? void 0 : saveHeart.vin}${suffix}` : `dg-inline-saves-${type}-${suffix}`}`,
    className: `${(saveHeart === null || saveHeart === void 0 ? void 0 : (_saveHeart$brand2 = saveHeart.brand) === null || _saveHeart$brand2 === void 0 ? void 0 : _saveHeart$brand2.toLowerCase()) === "lexus" ? "dg-heart-lexus" : "dg-encircle"} dg-inline-saves-container`,
    onClick: function (e) {
      return e.stopPropagation();
    },
    onKeyDown: function (e) {
      return e.stopPropagation();
    },
    ref: ref,
    "data-testid": "DGSaveHeart"
  });
});
var _default = exports.default = DGSaveHeart;